import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getLogFile() {
      console.log("getting the log file...");
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/logs/getLogFile",
            method: "GET"
          })
          .then(resolve)
          .catch(reject);
      });
    }
  },
  module: {},
  getters: {}
};
